<div class="recipe-list-page">

  <div class="recipe-header">
    <h1>Recipes</h1>
    <button class="btn btn-success" (click)="openAddModal()">+ Add Recipe</button>
  </div>

  <!-- Empty state -->
  <div *ngIf="recipes.length === 0" class="empty-state">
    <p class="empty-message">No recipes yet — add the first one!</p>
    <button class="btn btn-success" (click)="openAddModal()">Add Recipe</button>
  </div>

  <!-- Feeling prompt -->
  <div *ngIf="showPrompt" class="feeling-prompt">
    <h2 class="feeling-question">What are you feeling?</h2>
    <div class="feeling-chips">
      <button
        *ngFor="let feeling of allFeelings"
        class="feeling-chip-btn"
        (click)="selectFeeling(feeling)">
        {{ feeling }}
      </button>
    </div>
    <button class="browse-all-btn" (click)="browseAllRecipes()">or browse all →</button>
  </div>

  <!-- Recipe grid -->
  <div *ngIf="showGrid">
    <div class="grid-status">
      <span *ngIf="selectedFeeling" class="active-feeling-tag">
        {{ selectedFeeling }}
        <button class="clear-feeling-btn" (click)="clearFilter()">✕</button>
      </span>
      <span class="recipe-count">
        {{ filteredRecipes.length }} recipe{{ filteredRecipes.length !== 1 ? 's' : '' }}
      </span>
    </div>

    <div class="recipe-grid">
      <div
        class="recipe-card"
        *ngFor="let recipe of filteredRecipes"
        [routerLink]="['/recipe', recipe.id]">
        <div class="recipe-card-name">{{ recipe.name }}</div>
        <div class="recipe-card-cuisine" *ngIf="recipe.cuisine">{{ recipe.cuisine }}</div>
        <div class="recipe-card-feelings" *ngIf="recipe.feelings.length > 0">
          <span class="feeling-tag" *ngFor="let f of recipe.feelings">{{ f }}</span>
        </div>
        <div class="recipe-card-attribution">by {{ recipe.addedBy }}</div>
      </div>

      <div class="recipe-card recipe-card-add" (click)="openAddModal()">
        + Add Recipe
      </div>
    </div>
  </div>

  <!-- Form modal -->
  <app-recipe-form
    *ngIf="showFormModal"
    [recipe]="editingRecipe"
    (saved)="onFormSaved()"
    (cancelled)="onFormCancelled()">
  </app-recipe-form>

</div>
